function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.99922 48H2.19922C1.09922 48 0.199219 47.1 0.199219 46V38C0.199219 36.9 1.09922 36 2.19922 36H9.99922C11.0992 36 11.9992 36.9 11.9992 38V46C11.9992 47.1 11.0992 48 9.99922 48Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M45.8 48H38C36.9 48 36 47.1 36 46V38C36 36.9 36.9 36 38 36H45.8C46.901 36 47.8 36.9 47.8 38V46C47.8 47.1 46.9 48 45.8 48Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M28.3 12H20.5C19.4 12 18.5 11.1 18.5 10V2C18.5 0.9 19.4 0 20.5 0H28.3C29.401 0 30.3 0.9 30.3 2V10C30.3 11.1 29.4 12 28.3 12Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M24 16V24",
  stroke: "black",
  strokeWidth: 4,
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M6.09961 32.2004V25.9004C6.09961 24.7994 6.99961 23.9004 8.09961 23.9004H39.8996C40.9996 23.9004 41.8996 24.8004 41.8996 25.9004V32.1004",
  stroke: "black",
  strokeWidth: 4,
  strokeMiterlimit: 10
});

var SvgTopo = function SvgTopo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTopo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/topo.ed2ff634.svg";
export { ForwardRef as ReactComponent };